function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Rect, {
  fill: "#002459",
  width: 62,
  height: 61,
  rx: 10
});

var _ref2 = /*#__PURE__*/React.createElement(Path, {
  d: "M20.328 21.542h14.13v1.759h-14.13zm0 5.432h21.739v1.759H20.328zm0 5.432h17.391v1.759H20.328zm0 5.976h21.739v1.759H20.328z",
  fill: "#17bf88"
});

function SvgIconViewPresentation(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 61
  }, props), _ref, _ref2);
}

export default SvgIconViewPresentation;